<script lang="ts">
    import { xFirstDot, yLineInterval } from "../config/lengths";
    import DotsComponent from "./DotsComponent.svelte";

    export let xRel: number;
    export let xLeftEnd: number;
    export let xRightEnd: number;
    export let yMiddle: number;
    export let dots: number;

    $: cx = xLeftEnd + xRel * (xRightEnd - xLeftEnd);

    $: scale = yLineInterval / 40;
</script>

<path
    style="fill: #000000; fill-rule: evenodd; stroke-width: 0"
    d="m 3.8445495,48.209315 c 2.61469,0.79432 4.67175,-1.61714 5.57016,-4.31238 0.8984105,-2.69524 16.7104905,-69.5372 17.2495405,-71.33403 0.53905,-1.79682 -0.35937,-4.49206 -1.79683,-4.67175 -1.43746,-0.17968 -3.23429,1.0781 -3.77334,3.59366 -0.53904,2.51555 -1.71153,6.15488 -2.78963,7.41266 -1.07809,1.25778 -6.91323,6.78227 -10.8662505,8.21973 -3.95302,1.43746 -10.84962,2.9872902 -11.32001,1.61714 -0.32006,-0.93228 1.72138,-1.27833 3.59365996,-3.59365 1.20101,-1.48521 2.33587004,-5.57016 1.79682004,-7.90604 -0.53905004,-2.33587 -2.69524,-7.90603 -7.366989,-9.70286 -4.6717485,-1.79683 -10.6012775,-0.53905 -13.8355655,4.1327 -3.234288,4.67175 -3.234288,11.49969 0.179684,15.27303 3.413969,3.7733302 9.343498,7.7263502 17.9682705,6.6482602 8.62476,-1.0781 14.3746105,-4.1327102 15.8120705,-5.2108002 1.43746,-1.0781 3.05461,-2.51556 3.05461,-2.51556 0,0 -15.6962205,54.82677 -16.59463054,57.16265 -0.89841,2.33587 0.60287004,4.53233 3.11843004,5.18724 z"
    transform="scale({scale}) translate({cx / scale} {yMiddle / scale})"
/>
<DotsComponent xFirstDotAbs={cx + xFirstDot * 1.1} {dots} yRel={0} {yMiddle} />
